export default __webpack_public_path__ + "static/media/instituteLogo.549c0ea4.jpg";